import React from 'react';
import { Coffee, Check } from 'lucide-react';
interface LoyaltyCardProps {
  stamps: number;
  storeName: string;
  onClose: () => void;
}
export function LoyaltyCard({
  stamps,
  storeName,
  onClose
}: LoyaltyCardProps) {
  const totalStamps = 10;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-120">
      <div className="bg-white w-full max-w-sm rounded-3xl p-6 shadow-2xl transform transition-all animate-in zoom-in-95 duration-200" data-id="element-121">
        <div className="text-center mb-6" data-id="element-122">
          <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-123">{storeName}</h3>
          <p className="text-gray-500" data-id="element-124">Collect 10 stamps for a free reward!</p>
        </div>

        <div className="grid grid-cols-5 gap-3 mb-8" data-id="element-125">
          {Array.from({
          length: totalStamps
        }).map((_, i) => {
          const isStamped = i < stamps;
          return <div key={i} className={`
                  aspect-square rounded-full flex items-center justify-center border-2 transition-all duration-500
                  ${isStamped ? 'bg-purple-600 border-purple-600 text-white scale-100 rotate-0' : 'bg-gray-50 border-gray-200 text-gray-300 scale-90 rotate-12'}
                `} data-id="element-126">
                {isStamped ? <Check size={16} strokeWidth={4} data-id="element-127" /> : <Coffee size={16} data-id="element-128" />}
              </div>;
        })}
        </div>

        <div className="bg-purple-50 rounded-xl p-4 mb-6 flex items-center gap-3" data-id="element-129">
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600" data-id="element-130">
            <Coffee size={20} data-id="element-131" />
          </div>
          <div data-id="element-132">
            <p className="text-xs font-bold text-purple-900 uppercase tracking-wide" data-id="element-133">
              Current Reward
            </p>
            <p className="text-sm text-purple-700" data-id="element-134">Free Coffee or Pastry</p>
          </div>
        </div>

        <button onClick={onClose} className="w-full py-3 bg-gray-900 text-white font-bold rounded-xl hover:bg-gray-800 transition-colors" data-id="element-135">
          Close
        </button>
      </div>
    </div>;
}